import { useEffect, useState } from "react";
import scheduleService from "../../services/schedule.service";
import { Path } from "../../constants/enum/path.emum";
import { Link } from "react-router-dom";
import BtnEditSche from "./btnEditSche";
import EditSchedule from "./editSchedule";
import DeleteSchedule from "./setting/deleteSchedule";
import Loadding from "../common/loadding";

const TableOpen = (props: any) => {
  const [openList, setOpenList] = useState([]);
  const { keyFind } = props;
  // console.log(typeof keyFind);
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      //ส่งไปค้นตรงนี้

      scheduleService.getScheduleOpen().then((res) => {
        setOpenList(
          res.data.filter(
            (item: any) =>
              item.type.includes(keyFind) ||
              item.year.toString().includes(keyFind),
          ),
        );
        setStatus(false);
      });
    })();
  }, [keyFind]);
  if (status) {
    return <Loadding />;
  }

  return (
    <>
      <table className="table table-hover table-responsive">
        <thead className="table-dark">
          <tr>
            <th>ปีการศึกษา {keyFind}</th>
            <th>ภาคการศึกษา</th>
            <th>ประเภทเอกสาร</th>
            <th>Handle</th>
          </tr>
        </thead>
        <tbody>
          {!(openList.length > 0) && (
            <tr>
              <td colSpan={4} className="text-danger">
                <i className="bi bi-folder-x"></i> ไม่พบข้อมูล
              </td>
            </tr>
          )}
          {/* ///////////////////////////////////////////////////////////////////////////////////////// */}
          {openList.length > 0 &&
            openList.map((schedule: any) => {
              return (
                <tr key={schedule.id}>
                  <td>{schedule.year}</td>
                  <td>{schedule.term}</td>
                  <td>{schedule.type === "mhesi" ? "อชว." : "มคอ."} | RMUTI</td>
                  <td>
                    <BtnEditSche id={schedule.id} sche={schedule} />{" "}
                    <EditSchedule schedule={schedule} />
                    <DeleteSchedule schedule={schedule} />{" "}
                    <Link
                      to={{
                        pathname: `${Path.SCHEDULES}/${schedule.id}`,
                        state: { schedule },
                      }}
                      type="button"
                      className="btn btn-sm btn-outline-success"
                    >
                      <i className="bi bi-pencil-square"></i> ตั้งค่ารายวิชา
                    </Link>{" "}
                  </td>
                </tr>
              );
            })}

          {/* ///////////////////////////////////////////////////////////////////////////////////////// */}
        </tbody>
      </table>
    </>
  );
};

export default TableOpen;
